var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.335 9.176a1.185 1.185 0 000 1.651l5.714 5.831a1.128 1.128 0 001.618 0 1.185 1.185 0 000-1.65L5.9 11.165h10.958c.632 0 1.143-.52 1.143-1.166 0-.645-.51-1.166-1.143-1.166H5.903l3.76-3.841a1.185 1.185 0 000-1.651 1.129 1.129 0 00-1.617 0L2.33 9.172l.004.004z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default ForwardRef;